import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TopContent = styled.div`
  display: flex;
  width: 100%;
`;

export const Initials = styled.span`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 80px;
  width: 80px;
  font-size: 32px;
  border-radius: 100%;
  color: ${({ theme }) => theme.userMenu.initials};
  background-color: ${({ theme }) => theme.userMenu.initialsBackground};
`;

export const CircleSpin = styled.div`
  position: absolute;
  left: -10px;
  top: -10px;
  width: 100px;
  height: 100px;

  & svg {
    width: 100%;
    height: 100%;
    overflow: initial;
  }

  & circle {
    stroke-width: 3;
    stroke-dasharray: 50, 10;
    fill: none;
    stroke: ${({ theme }) => theme.userMenu.circleBorder};
  }
`;

export const Title = styled.h5`
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.userMenu.color};
`;

export const Email = styled.span`
  margin-top: 10px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.userMenu.color};
`;

export const GoBackButton = styled.div`
  position: absolute;
  left: 15px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;
